<template>
  <div>
    <main class="main">
      <div
        class="page-header text-center"
        style="background-image: url('/img/wallpaperbetter.jpg')"
      >
        <div class="container">
          <h1 class="page-title">Il tuo account<span>Neurohub</span></h1>
        </div>
        <!-- End .container -->
      </div>
      <!-- End .page-header -->
      <nav aria-label="breadcrumb" class="breadcrumb-nav mb-3">
        <div class="container">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/dashboard">Home</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Il tuo profilo
            </li>
          </ol>
        </div>
        <!-- End .container -->
      </nav>
      <LoadedComponent :loading="loading" />

      <div class="dashboard">
        <div class="container">
          <AlertComponent
            :alert-type="'success'"
            :message="successMessage"
          ></AlertComponent>
          <div class="row">
            <aside class="col-md-4 col-lg-3">
              <ul
                class="nav nav-dashboard flex-column mb-3 mb-md-0"
                role="tablist"
              >
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    id="tab-dashboard-link"
                    data-toggle="tab"
                    href="#tab-dashboard"
                    role="tab"
                    aria-controls="tab-dashboard"
                    aria-selected="true"
                    >I tuoi dati</a
                  >
                </li>

                <li class="nav-item">
                  <a class="nav-link" href="#" @click="logout"> Sign Out</a>
                </li>
              </ul>
            </aside>
            <!-- End .col-lg-3 -->

            <div class="col-md-8 col-lg-9">
              <div class="tab-content">
                <div
                  class="tab-pane fade show active"
                  id="tab-dashboard"
                  role="tabpanel"
                  aria-labelledby="tab-dashboard-link"
                >
                  <form method="POST" @submit.prevent="update_profile">
                    <div class="row">
                      <div class="col-md-6 mb-2">
                        <img
                          :src="user.photo"
                          alt=""
                          class="img-thumbnail"
                          style="max-width: 180px"
                        />
                      </div>
                      <div class="col-md-6 mb-2 d-flex align-items-center">
                        <div class="input-group mb-3">
                          <div class="custom-file">
                            <input
                              type="file"
                              class="custom-file-input"
                              name="link_2"
                              @change="handleFileUpload"
                              id="link_2"
                              aria-describedby="inputGroupFileAddon01"
                            />
                            <label
                              class="custom-file-label text-center"
                              for="link_2"
                              id="labelsfiles"
                              >{{ nameFiles }}</label
                            >
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <label>Nome *</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Inserisci il tuo nome"
                          v-model="form.name"
                        />
                        <div class="alert alert-danger" v-if="errors.name">
                          {{ errors.name[0] }}
                        </div>
                      </div>
                      <!-- End .col-sm-6 -->

                      <div class="col-sm-6">
                        <label>Cognome *</label>
                        <input
                          type="text"
                          class="form-control"
                          name="cognome"
                          v-model="form.lastname"
                          placeholder="Inserisci il tuo cognome"
                        />
                        <div class="alert alert-danger" v-if="errors.lastname">
                          {{ errors.lastname[0] }}
                        </div>
                      </div>
                      <!-- End .col-sm-6 -->
                    </div>
                    <!-- End .row -->

                    <label>Email *</label>
                    <input
                      type="email"
                      class="form-control"
                      v-model="form.email"
                      placeholder="Inserisci la email"
                    />
                    <div class="alert alert-danger" v-if="errors.email">
                      {{ errors.email[0] }}
                    </div>

                    <label>Cellulare </label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.phone"
                      placeholder="Inserisci il prefisso se estero"
                    />
                    <div class="alert alert-danger" v-if="errors.phone">
                      {{ errors.phone[0] }}
                    </div>

                    <label>Ospedale</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.hospital"
                      placeholder="Inserisci il tuo ospedale"
                    />
                    <div class="alert alert-danger" v-if="errors.hospital">
                      {{ errors.hospital[0] }}
                    </div>

                    <label>Specializzazione</label>
                    <select
                      class="form-control"
                      v-model="form.specialisation_id"
                    >
                      <option
                        v-for="specialisation in specialisations"
                        :key="specialisation.id"
                        :value="specialisation.id"
                      >
                        {{ specialisation.name }}
                      </option>
                    </select>
                    <div
                      class="alert alert-danger"
                      v-if="errors.specialisation_id"
                    >
                      {{ errors.specialisation_id[0] }}
                    </div>

                    <label>Qualifica</label>
                    <select
                      class="form-control"
                      v-model="form.qualification_id"
                    >
                      <option
                        v-for="qualification in qualifications"
                        :key="qualification.id"
                        :value="qualification.id"
                      >
                        {{ qualification.name }}
                      </option>
                    </select>
                    <div
                      class="alert alert-danger"
                      v-if="errors.qualification_id"
                    >
                      {{ errors.qualification_id[0] }}
                    </div>

                    <label>Nuova password</label>
                    <input
                      type="password"
                      name="password"
                      class="form-control"
                      placeholder="Scrivi la nuova password"
                      v-model="form.password"
                    />
                    <div class="alert alert-danger" v-if="errors.password">
                      {{ errors.password[0] }}
                    </div>

                    <label>Conferma nuova password</label>
                    <input
                      type="password"
                      name="password_confirmation"
                      class="form-control"
                      placeholder="Conferma la password"
                      v-model="form.password_confirmation"
                    />

                    <button type="submit" class="btn btn-outline-primary-2">
                      <span>Salva i cambiamenti</span>
                      <i class="icon-long-arrow-right"></i>
                    </button>
                  </form>
                </div>
              </div>
              <!-- End .col-lg-9 -->
            </div>
            <!-- End .row -->
          </div>
          <!-- End .container -->
        </div>
        <!-- End .dashboard -->
      </div>

      <!-- End .page-content -->
    </main>
  </div>
  <!-- End .main -->
</template>
<script>
import httpauth from "@/services/httpauth.js";
import { useAuth } from "@/stores/auth.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import AlertComponent from "@/components/AlertComponent.vue";
import http from "@/services/http.js";

export default {
  name: "ProfilePage",
  components: {
    LoadedComponent,
    AlertComponent,
  },
  data() {
    return {
      user: {},
      errors: [],
      loading: true,
      form: {
        name: "",
        lastname: "",
        email: "",
        photo: null,
        password: "",
        phone: "",
        password_confirmation: "",
        qualification_id: "",
        specialisation_id: "",
        hospital: "",
      },
      successMessage: "",
      qualifications: [],
      specialisations: [],
      nameFiles: "Scegli una foto",
      selectedFile: null,
    };
  },
  mounted() {
    this.qualificationsData();
    this.specialisationsData();
    this.loadUser();
  },
  methods: {
    async loadUser() {
      await httpauth
        .get("/profile")
        .then((response) => {
          this.user = response.data.data;
          this.loading = false;
          this.form = {
            name: this.user.name,
            lastname: this.user.lastname,
            email: this.user.email,
            photo: null,
            password: "",
            password_confirmation: "",
            qualification_id: this.user.qualification_id,
            phone: this.user.phone,
            specialisation_id: this.user.specialisation_id,
            hospital: this.user.hospital,
          };
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          ) {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async qualificationsData() {
      var { data } = await http.get("/qualifications");
      this.qualifications = data.data;
    },
    async specialisationsData() {
      var { data } = await http.get("/specialisations");
      this.specialisations = data.data;
    },
    async update_profile() {
      const formData = new FormData();

      formData.append("name", this.form.name);
      formData.append("lastname", this.form.lastname);
      formData.append("email", this.form.email);
      formData.append("photo", this.form.photo);
      formData.append("phone", this.form.phone);
      formData.append("password", this.form.password);
      formData.append("password_confirmation", this.form.password_confirmation);
      formData.append("qualification_id", this.form.qualification_id);
      formData.append("specialisation_id", this.form.specialisation_id);
      formData.append("hospital", this.form.hospital);
      await httpauth
        .post("/profile/update", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.form.photo = null;
          this.loadUser();
          this.successMessage = response.data.message;
        });
    },
    async logout() {
      httpauth
        .get("/logout")
        .then((response) => {
          if (response.data.status) {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          ) {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    handleFileUpload(event) {
      const maxSize = 1 * 1024 * 1024 * 1024;
      const files = event.target.files[0];
      const totalSize = files.size;
      const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (totalSize <= maxSize) {
        if (!allowedTypes.includes(files.type)) {
          alert("Per favore seleziona un file valido (JPEG/JPG/PNG).");
          this;
          return;
        }
        this.nameFiles = files.name;
        this.form.photo = files;
      } else {
        alert("La dimensione totale dei file supera 1 GB");
      }
    },
  },
};
</script>
